var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 830.9 286.6",
      },
    },
    [
      _c("defs", [
        _c("path", { attrs: { id: "A", d: "M0 0h830.9v286.6H0z" } }),
      ]),
      _vm._v(" "),
      _c("clipPath", { attrs: { id: "B" } }, [
        _c("use", { attrs: { "xlink:href": "#A" } }),
      ]),
      _vm._v(" "),
      _c(
        "g",
        { attrs: { "clip-path": "url(#B)" } },
        [
          _c("path", {
            attrs: {
              d: "M830.9 61.2v197.1l-26.8 26.8v-193l26.8-30.9z",
              fill: "#dc7e28",
            },
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "C",
                gradientUnits: "userSpaceOnUse",
                x1: "622.059",
                y1: "87.308",
                x2: "800.809",
                y2: "284.238",
              },
            },
            [
              _c("stop", {
                attrs: { offset: ".006", "stop-color": "#f8c51b" },
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#e78f24" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            attrs: { d: "M804.1,92.1H623.9v193h180.2V92.1z", fill: "url(#C)" },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M652.2 61.3l-28.3 30.8h180.2l26.8-30.9-178.7.1z",
              fill: "#fdd600",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M429 69.8l177.2-24.7-14.8 42.5-174.8 23.9L429 69.8z",
              fill: "#90c7ea",
            },
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "D",
                gradientUnits: "userSpaceOnUse",
                x1: "422.841",
                y1: "111.299",
                x2: "607.191",
                y2: "259.339",
              },
            },
            [
              _c("stop", {
                attrs: { offset: ".006", "stop-color": "#1e8aca" },
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#01659e" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M591.4 87.6L616 260.5l-174.8 24.6-24.6-173.6 174.8-23.9z",
              fill: "url(#D)",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M591.4 87.6L616 260.5l13.4-37.3-23.2-178.1",
              fill: "#0b98d5",
            },
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "E",
                gradientUnits: "userSpaceOnUse",
                x1: "322.3",
                y1: "119.33",
                x2: "322.3",
                y2: "280.87",
              },
            },
            [
              _c("stop", { attrs: { offset: "0", "stop-color": "#269f49" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#008a54" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M279.3 55l156.9 70.8-70.8 160.8-157-70.8L279.3 55z",
              fill: "url(#E)",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M263,0l16.3,55l156.9,70.8L423,73.3L263,0z",
              fill: "#95cea0",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M263,0l-63.2,149.9l8.6,65.9L279.3,55L263,0z",
              fill: "#69bf6d",
            },
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "F",
                gradientUnits: "userSpaceOnUse",
                x1: "87.981",
                y1: "103.528",
                x2: "115.761",
                y2: "271.238",
              },
            },
            [
              _c("stop", { attrs: { offset: "0", "stop-color": "#d81f32" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#bb2637" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M175.4 87.4l25.9 170.1-173.4 27.2L0 114.2l175.4-26.8z",
              fill: "url(#F)",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M187.3 25.4L213 197.2l-11.7 60.3-25.9-170.1 11.9-62z",
              fill: "#761216",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M776.6 161.5c-3.6-9-8.8-17-15.8-24.1-6.7-6.8-14.2-12-22.5-15.4-8.3-3.5-17.3-5.2-26.9-5.2-9.7 0-18.8 1.7-27.1 5.2-8.4 3.5-15.9 8.6-22.5 15.4-7 7-12.2 15-15.7 24s-5.2 18.7-5.2 29.3c0 10.4 1.8 20.2 5.3 29.2s8.8 17.1 15.7 24.3c6.5 6.7 13.9 11.8 22.2 15.2s17.5 5.1 27.4 5.1c9.6 0 18.5-1.7 26.9-5.1 8.3-3.4 15.9-8.5 22.5-15.2 7-7.2 12.3-15.2 15.8-24.2 3.6-9 5.4-18.8 5.4-29.3-.1-10.5-1.9-20.2-5.5-29.2zm-37 63.6c-6.9 8.3-16.2 12.5-28.2 12.5-12.1 0-21.4-4.1-28.4-12.4-6.9-8.3-10.4-19.7-10.4-34.4 0-14.9 3.5-26.5 10.4-34.9s16.3-12.5 28.4-12.5c12 0 21.3 4.2 28.2 12.5 6.9 8.4 10.4 20 10.4 34.9 0 14.6-3.5 26-10.4 34.3zm-582.8 5.3c-1.4-1.6-3.2-2.8-5.4-3.6-2.3-.8-5.1-1.2-8.4-1.2-3.1 0-6.6.3-10.6 1l-45.8 7.8c.5-3.5 2.2-8.2 5.3-13.8 3.4-6.3 8.5-13.9 15.3-22.8l5.3-7.1c.9-1.1 2.1-2.7 3.7-4.8 10.5-13.7 17-24.9 19.4-33.7 1.4-5 2.3-10 2.6-15 .1-1.4.1-2.8.1-4.1 0-3.6-.3-7.2-.9-10.7-.5-3.2-1.3-5.9-2.4-8s-2.4-3.7-4-4.8c-1.9-1.1-4.5-1.6-7.9-1.6-2.8 0-6.2.3-10.2 1L60 118.1c-6.4 1.1-11.1 3-14.2 5.8-2.4 2.3-3.6 5.2-3.6 8.5 0 .9.1 1.8.2 2.7.7 4.5 3.1 7.8 6.9 9.5 2.2 1 4.9 1.5 8.1 1.5 2.1 0 4.5-.2 7.1-.7l44.3-7.5c.1.8.1 1.6.1 2.3 0 2.8-.5 5.5-1.4 8.1-1.3 3.7-4.6 8.9-9.8 15.6-1.5 1.8-3.8 4.7-6.8 8.5C78.7 187 70.2 199.3 65 209.6c-3.7 7.1-6.2 14-7.6 20.9-.8 4-1.2 7.8-1.2 11.5a48.98 48.98 0 0 0 .6 7.7c.6 3.5 1.5 6.5 2.7 8.8s2.7 4 4.5 5c1.7.9 4.3 1.3 7.8 1.3 4.4 0 10.4-.7 17.9-1.9l48-8.2c8.5-1.5 14.4-3.5 17.8-6.3 2.7-2.3 4.2-5.4 4.2-9a15.04 15.04 0 0 0-.3-2.9c-.4-2.4-1.2-4.5-2.6-6.1zm217.7-115c-6.2-6.5-13.7-11.6-22.4-15.3s-17.5-5.6-26.4-5.6h-.4c-9 .1-17.9 2.1-26.7 6-9.2 4-17.2 9.6-24 16.8s-12.3 15.8-16.6 25.9c-4.2 10-6.6 19.9-7 29.9-.1 1.1-.1 2.3-.1 3.4 0 8.8 1.5 17.4 4.5 25.8 3.2 8.9 7.9 16.6 14.1 23.1s13.9 11.6 22.9 15.5c8.6 3.7 17.4 5.5 26.3 5.5h.2c9 0 17.9-2 26.7-5.7 9.3-4.1 17.3-9.8 24.2-17s12.4-15.8 16.7-25.8c4.2-10 6.6-20 6.9-29.9 0-1 .1-1.9.1-2.9 0-8.9-1.6-17.7-4.7-26.2-3.4-9.2-8.2-17-14.3-23.5zm-17.2 70.1c-5.9 13.9-13.7 23.5-23.4 28.8-5.2 2.8-10.5 4.2-16 4.2-4.8 0-9.7-1.1-14.8-3.2-11-4.7-17.8-12.2-20.8-22.8-1-3.6-1.5-7.3-1.5-11.2 0-7.8 2-16.3 5.9-25.6 6-14.3 13.9-24 23.6-29.3 5.2-2.8 10.5-4.3 16-4.3 4.8 0 9.8 1.1 15 3.3 10.9 4.6 17.7 12.2 20.6 22.8.9 3.5 1.4 7.2 1.4 11 .1 7.9-1.9 16.7-6 26.3zm204.4-64.8c-.8-5.4-2.6-9.5-5.6-12.1-2.4-2.1-5.3-3.2-8.7-3.2-.9 0-1.8.1-2.7.2-4.5.7-8 2.8-10.1 6.2-1.5 2.5-2.3 5.5-2.3 9 0 1.3.1 2.7.3 4.2l6.4 45-50.3 7.4-6.4-45c-.8-5.2-2.6-9.3-5.5-12-2.4-2.2-5.3-3.4-8.6-3.4-.8 0-1.6.1-2.4.2-4.7.7-8.3 2.7-10.5 6.2-1.6 2.5-2.4 5.5-2.4 9 0 1.4.1 2.8.3 4.3l17.2 117c.8 5.4 2.7 9.5 5.8 12.1 2.4 2.1 5.4 3.1 8.9 3.1.9 0 1.9-.1 2.9-.2 4.3-.6 7.7-2.7 9.7-6.2 1.4-2.5 2.1-5.4 2.1-8.8 0-1.4-.1-2.8-.3-4.3l-7-46.2 50.3-7.4 7 46.2c.8 5.3 2.6 9.4 5.7 12 2.4 2.1 5.4 3.2 8.8 3.2.9 0 1.8-.1 2.7-.2 4.5-.7 8-2.7 10-6.2 1.5-2.5 2.2-5.4 2.2-8.9 0-1.4-.1-2.8-.3-4.3l-17.2-116.9z",
              fill: "#fff",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M0 114.2l3.4-17.1 8.8-43.6 175.1-28.1-11.9 62L0 114.2z",
              fill: "#ec473f",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }